import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {PackageConfigurationEntity} from "../../models/package-configuration.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {SettingsService} from "../../services/settings-service.service";


export class PackageConfigurationSelectListComponent implements IController {

  options: any;
  selectedId: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  public packageConfigurations: PackageConfigurationEntity[]
  public loading: boolean = false;
  public queryString: string = "";


  constructor(private settingsService: SettingsService) {
  }

  $onInit() {


    if (!this.options) {
      this.loading = true;
      this.settingsService.getAllPackageConfigurations()
        .then((packageConfigurations: PackageConfigurationEntity[]) => {
          this.packageConfigurations = packageConfigurations;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationSelectList', {
    bindings: {
      selectedId: '<',
      options: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./package-configuration-select-list.html').default,
    controller: PackageConfigurationSelectListComponent
  });
